import * as Mui from "@mui/material";
import { useEffect, useState, useContext  } from "react";
import { useForm } from "react-hook-form";
import CustomLoader from "../../../util/component/CustomLoader";
import SectionHeader from "../../../util/component/SectionHeader";
import ParkingToolFilter from "./ParkingToolFilter";
import ParkingToolService from "./ParkingToolService";
import ParkingToolTable from "./ParkingToolTable";
import ParkingToolSpace from "./ParkingToolTypes";
import noLocation from "./nosupplier.png";
import { useTranslation } from "react-i18next";
import { ContextParkingTool } from "./ParkingToolContext";

type Props = {}

const ParkingTool = (props: Props) => {
  const { t } = useTranslation(["network"]);

  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState<ParkingToolSpace.Response>();  
  const parkingToolContext = useContext(ContextParkingTool);
  
  const form = useForm<ParkingToolSpace.FormInputs>({
    defaultValues: {
      today: true,
    }
  });
  
  const onSubmit = (data: ParkingToolSpace.FormInputs) => {
    getData(data);
  }

  const getData = (data: ParkingToolSpace.FormInputs) => {
    const selectedLocation = data.location;
    const tenant = data.tenant;

    if (!tenant || !selectedLocation) {
      console.warn("no tenant or location selected!");
      return;
    }

    const pickupList: ParkingToolSpace.PickUp[] = [];
    if (selectedLocation) {
      pickupList.push({
        locationId: selectedLocation.bpCode,
        locationType: selectedLocation.typeEnum,
      })
    }

    const request: ParkingToolSpace.Request = {
      currentDay: data.today === true ? true : false,
      pickUpList: pickupList
    }

    setLoading(true);
    ParkingToolService.post.getAvailabilityForParkingTool(tenant, request).then(
      (response) => {
        setLoading(false);
        setDatas(response);
      },
    )
	
	parkingToolContext.tenant = tenant;
    parkingToolContext.request = request;


  }

  useEffect(() => {
    if (!form.watch("location")) {
      setDatas(undefined);
    }
  }, [form.watch("location")]);

  return (
    <Mui.Box>
      <SectionHeader
        title={"Parking tool"}
      />

      <Mui.Stack px={1} margin={2} gap={2}>
        <ParkingToolFilter form={form} onSubmit={onSubmit} />

        {datas?.singleLocationAvailabilityParkingToolResponses?.length === 0 && (
          <Mui.Stack
            sx={{ height: "500px" }}
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={2}
          >
            <Mui.Box>
              <img src={noLocation} />
            </Mui.Box>
            <Mui.Box>
              <p className="notSupplietClass">
                {t("parkingTool.noLocation")}
              </p>
            </Mui.Box>
          </Mui.Stack>
        )}

        {datas?.singleLocationAvailabilityParkingToolResponses?.map(
          singleLocationAvailability => (
            <ParkingToolTable
              singleLocationAvailability={singleLocationAvailability}
              threshold={datas.configurationThresholds}
              getData={() => getData(form.getValues())}
            />
          )
        )}
      </Mui.Stack>

      <CustomLoader loading={loading} />
    </Mui.Box>
  )
}

export default ParkingTool;